<template>
<div class="top-performer">
    <div class="home_slider">
        <div class="slider__header border">
            <ul class="slider_tabs">
                <li><a v-bind:class="{ active: currentab == 'MVP CANDIDATE' }"  @click="setTab('MVP CANDIDATE')">MVP Candidates</a></li>
                <li><a v-bind:class="{ active: currentab == 'ALL NBA' }"  @click="setTab('ALL NBA')">All-NBA</a></li>
                <li><a v-bind:class="{ active: currentab == 'ALL STAR' }"  @click="setTab('ALL STAR')">All-Stars</a></li>

                <li><a v-bind:class="{ active: currentab == 'IMPACT STARTER' }"  @click="setTab('IMPACT STARTER')">Impact Starters</a></li>
                <li><a v-bind:class="{ active: currentab == 'STARTER' }"  @click="setTab('STARTER')">Starters</a></li>
                <li><a v-bind:class="{ active: currentab == 'KEY RESERVE' }"  @click="setTab('KEY RESERVE')">Key Reserves</a></li>

       
            </ul>
            <div class="slider__header_actions"> 
                <div class="slider_navigation">
                    <div class="swiper-button-prev home-slider5_left"> 
                    </div>
                    <div class="swiper-button-next home-slider5_right"></div>
                </div>
            </div>            
        </div>
        
       <swiper ref="awesomeSwiperA" :options="swiperOption">
        <template v-for="(player, index) in playerslist">
          <swiper-slide :key="index">
            <div class="performer_block profile_rating">
              <div class="player_profile ">
                <div class="player_dp">
                  <figure>
                    <template v-if="player.PLAYER_IMAGE">
                      <img
                        :src="player.PLAYER_IMAGE"
                        class="align-self-center"
                        :alt="player.PLAYER_NAME"
                      />
                    </template>
                    <template v-else>
                      <img
                        :src="
                          'https://profitx.ai/api/viewfile?path=playerimages/' +
                          player.GPlayerID +
                          '.png'
                        "
                        class="align-self-center"
                        :alt="player.PLAYER_NAME"
                      />
                    </template>
                  </figure>
                  <span class="teamLogo" v-if="player.team"><img :src="player.team.logo" /></span>
                </div>
                <div class="player_info">
                  <h4>{{ player.PLAYER_NAME }}</h4>
                  <p>
                    {{ getposition(player.Position) }} | {{ player.AGE }} Years
                  </p>

                  <div v-if="currentab == 2" class="gradient_btn">
                    <p>
                      <span>TC</span>
                      {{ player.TC | currency }}
                    </p>
                  </div>
                   <div class="player_actions">
                      <div class="gradient_btn">
                        <p>
                          <span>ProFitX Ranking</span>
                    
                          {{ player.RANK}}
                        </p>
                      </div>
                    </div>
                  
                </div>
              </div>
              <!-- <div class="player_actions">
                <div class="gradient_btn">
                  <p>
                    <span>ProFitX Ranking</span>
              
                    {{ player.RANK}}
                  </p>
                </div>
              </div> -->
            </div>
          </swiper-slide>
        </template>
      </swiper>
    </div>
    
    

    
</div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";


export default {
  components: {
    swiper,
    swiperSlide,
  },
  methods: {
    getroles(type) {
      const keys = Object.keys(type);
      var returnvalues = [];
      keys.forEach((key, index) => {
        returnvalues.push({
          k: key,
          v: type[key] * 100,
        });
      });

      var formated = this.lodash.orderBy(returnvalues, ["v"], ["desc"]);

      var finals = "";

      formated.forEach(function (_role, index) {
        if (index <= 3) {
          if (finals != "") {
            finals = finals + " | " + _role["k"];
          } else {
            finals = _role["k"];
          }
        }
      });

      return finals;
    },
    getposition(type) {
      var _p = this.lodash.find(this.positions, function (my) {
        return my.value == type;
      });
      if (_p) return _p.name;
      return "";
    },
    setTab(tab) {
      this.playerslist = [];
      this.currentab = tab;
       this.$store.dispatch("getoutlookplayers",{"outlook":tab}).then((response) => {
          this.playerslist = [];
          var _games = [];
          if (response && response.length > 0) {
            this.playerslist = response;
          }
        });
    },
  },
  data: () => ({
    positions: [
      {
        name: "Power Forward",
        value: "F-C",
      },
      {
        name: "Forward",
        value: "F",
      },
      {
        name: "Versatile Center",
        value: "C-F",
      },
      {
        name: "Center",
        value: "C",
      },
      {
        name: "Combo Guard",
        value: "G-F",
      },
      {
        name: "Guard",
        value: "G",
      },
      {
        name: "Wing",
        value: "F-G",
      },
    ],
    currentab: 'MVP CANDIDATE',
    playerslist: [],
    swiperOption: {
      slidesPerView: "auto",
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: ".home-slider5_right",
        prevEl: ".home-slider5_left",
      },
    },
  }),
  mounted() {
    this.setTab('MVP CANDIDATE');
  },
  computed: {},
};
</script> 